import { render, staticRenderFns } from "./RequestTrackingComponent.vue?vue&type=template&id=2df4c224&"
import script from "./RequestTrackingComponent.vue?vue&type=script&lang=ts&"
export * from "./RequestTrackingComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports